import { HomeActions, HomeActionTypes } from './home.actions';

import * as _ from 'lodash';
import { HomeStateInterface } from './home.model';

export const initialState: HomeStateInterface = {
  errors: [],
  homeInformationLoading: false,
  homeInformationLoaded: false,
};

export function homeReducer(state = initialState, action: HomeActions): HomeStateInterface {
  switch (action.type) {
    case HomeActionTypes.FetchError:
      return _.assign(
        {
          ...state,
          errors: action.payload,
        },
      );
    default:
      return state;
  }
}
